export class UserAddons {
    hasVrm: boolean;
    hasVin: boolean;
    hasCar: boolean;
    hasLcv: boolean;
    hasHgv: boolean;
    hasBike: boolean;
}



// WEBPACK FOOTER //
// ./src/app/settings/models/user-addons.model.ts